import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EjecutivosService } from '@app/shared/services/ejecutivos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-lista-profesores',
  templateUrl: './lista-profesores.component.html',
  styleUrls: ['./lista-profesores.component.css']
})
export class ListaProfesoresComponent implements OnInit {
  p:number=1;
  constructor(private ejecutivosService: EjecutivosService,private cdr: ChangeDetectorRef,
    private router: Router) { }

    public isLoading = true;
    public profesores : any[] =[];
    searchText:string;
  ngOnInit(): void {
    this.getListEjecutivos();
  }
  
  onSearchTextChanged() {
    this.p = 1;
  }

  getListEjecutivos(){
    this.ejecutivosService.getteachers().subscribe((resp: any) => {
      this.isLoading = false;
      this.profesores = resp.data;
      this.cdr.detectChanges();
    });
  }

  editar(item:any){
    this.ejecutivosService.datosAEditar = item;
    this.router.navigate(['/profesores/admin','editar']);
   }

   getTypeDescription(type: number): string {
    return this.ejecutivosService.getTypeDescription(type).name;
  }

   eliminar(item:any){
     Swal.fire({
       title: 'Eliminar profesor',
       text: '¿Realmente desea eliminar este profesor?.',
       icon: 'question',
       showCancelButton: true,
       confirmButtonText: 'Sí',
       denyButtonText: 'No',
     }).then((result) => {
       if (result.isConfirmed) {
         console.log("eliminando item",item.identity);
         this.ejecutivosService.delete(item.identity).subscribe((resp: any) => {
           if(resp.code == 200){
             Swal.fire({
               title: '',
               text: 'Profesor eliminado correctamente.',
               icon: 'success',
               confirmButtonText: 'OK'
             }).then((result2) => {
               this.getListEjecutivos();
             });
           }else{
             Swal.fire(
               '',
               'No se pudo eliminar profesor, favor comuníquese con el administrador.',
               'error'
               );
           }
           this.cdr.detectChanges();
   
         });
         this.cdr.detectChanges();
       }
     });
   }
}
